// src/pages/Jurnal.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCalendarDay, FaCalendarAlt } from 'react-icons/fa';
import BottomNavbar from '../components/BottomNavbar';

function Jurnal() {
  const navigate = useNavigate();

  const cards = [
    {
      icon: <FaCalendarDay size={24} />,
      title: 'Jurnal Harian',
      route: '/jurnal-harian',
      bg: 'primary',
    },
    {
      icon: <FaCalendarAlt size={24} />,
      title: 'Jurnal Mingguan',
      route: '/jurnal-mingguan',
      bg: 'success',
    },
  ];

  return (
    <div className="container">
      <h1 className="text-center mt-4">Jurnal</h1>

      <div className="row g-3 mt-2">
        {cards.map((card, idx) => (
          <div className="col-12" key={idx}>
            <div
              className={`card shadow-sm border-0 hover-shadow cursor-pointer`}
              role="button"
              onClick={() => navigate(card.route)}
            >
              <div className="card-body d-flex align-items-center">
                <div
                  className={`bg-${card.bg} text-white rounded-circle d-flex justify-content-center align-items-center me-3`}
                  style={{ width: '48px', height: '48px' }}
                >
                  {card.icon}
                </div>
                <h5 className="mb-0 fw-semibold">{card.title}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-5">
        <BottomNavbar />
      </div>
    </div>
  );
}

export default Jurnal;
